
import { Moon, Sun } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useTheme } from "@/components/theme-provider";
import { cn } from "@/lib/utils";

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  
  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <div className={cn("flex items-center space-x-2 p-1 rounded-full bg-muted/50 dark:bg-gray-800 border border-border/50 shadow-sm transition-all duration-300", className)}>
      <Sun className={cn("h-4 w-4 ml-1", theme === "light" ? "text-gold" : "text-gray-400")} />
      <Switch
        checked={theme === "dark"}
        onCheckedChange={toggleTheme}
        aria-label="Cambia tema"
      />
      <Moon className={cn("h-4 w-4 mr-1", theme === "dark" ? "text-white" : "text-gray-400")} />
    </div>
  );
}
